import * as React from 'react';
import { Fragment } from 'react';
import {
  DatagridConfigurable,
  DateField,
  TextField,
  ReferenceField,
  FunctionField,
  WrapperField,
  TextInput,
  SelectInput
} from 'react-admin';
import { useMediaQuery, Divider, Theme} from '@mui/material';
import ComponentList from '../../components/PageComponents/ComponentList';
import MobileGrid from './MobileGrid';
import { Helmet } from 'react-helmet-async';
import { BulkActionButtons, ListActions, ListButtons } from '../../components/PageComponents/ComponentList';
import { StatusLabel } from "../../components/Label/status";
import { statusText } from "../../components/Label";
import { AccountFilter } from "../../components/PageComponents/ComponentList";
import { formatDate, linkAmount } from "../../utils/paymentFormat";
import { datagridSx } from "../../components/PageComponents/datagridSx";


const PaymentLinkList = () => (
  <>
      <Helmet>
      <title>Coinhouse Solutions - Payment links</title>
    </Helmet>
  <ComponentList title="Payment links" subtitle="Payment requests sent to customers, with their amount, expiry and status." /* filters={orderFilters} */ actions={<ListActions ressource="paymentLinks" filters={paymentLinkFilters}/>}>
  <TabbedDatagrid />
  </ComponentList>
  </>
);




const statuses = ["pending", "done", "failed", "activated", "expired"];
const paymentLinkFilters = [
  /*   <DateInput source="dateCreated" />,
   */
  <AccountFilter />,
  <TextInput source="internalRef" label="Reference" helperText={false} />,
  <SelectInput
    source="statusPaymentLink"
    label="Status"
    helperText={false}
    choices={statuses.map((key) => ({
      id: key,
      name: statusText(key),
    }))}
  />,
];

const TabbedDatagrid = () => {
  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <Fragment>
      <Divider />
      {isXSmall ? (
        <MobileGrid />
      ) : (
        <>
          <DatagridConfigurable
            bulkActionButtons={<BulkActionButtons ressource="paymentLinks" />}
            rowClick="show"
            sx={datagridSx}
          >
            <DateField source="dateCreated" label="Created" showTime locales="fr-FR" />
            <TextField sortable={false} source="internalRef" label="Reference" />
            <WrapperField sortable={false} label="Status">
              <StatusLabel statusField="statusPaymentLink"/>
            </WrapperField>
            <FunctionField sortable={false} label="Customer" render={(record) => record.params?.customerName || record.params?.customerEmail || "—"} />
            <FunctionField sortable={false} label="Amount" textAlign="right" render={(record) => linkAmount(record.params)} />
            <FunctionField sortable={false} source="expiresAt" label="Expires at" render={(record) => formatDate(record.expiresAt)} />
            <ReferenceField source="orderId" reference="cryptoOrders" label="Transaction" link="show" sortable={false} />
            <ListButtons ressource="paymentLinks" />
          </DatagridConfigurable>
        </>
      )}
    </Fragment>
  );
};

export default PaymentLinkList;